module.exports = __webpack_public_path__ + "img/icon3.b9d55253.gif";